import { useEffect } from "react";

export function DrawerDismissController() {
  useEffect(() => {
    function closeDrawer(backdrop: Element | null) {
      backdrop
        ?.querySelector<HTMLButtonElement>('button[aria-label="Cerrar"]')
        ?.click();
    }

    function handleBackdropClick(event: MouseEvent) {
      if (!(event.target instanceof Element)) return;
      const backdrop = event.target.closest(".drawer-backdrop");
      if (!backdrop || event.target.closest(".drawer")) return;
      closeDrawer(backdrop);
    }

    function handleEscape(event: KeyboardEvent) {
      if (event.key !== "Escape") return;
      const backdrops = document.querySelectorAll(".drawer-backdrop");
      closeDrawer(backdrops.item(backdrops.length - 1));
    }

    document.addEventListener("click", handleBackdropClick);
    document.addEventListener("keydown", handleEscape);
    return () => {
      document.removeEventListener("click", handleBackdropClick);
      document.removeEventListener("keydown", handleEscape);
    };
  }, []);

  return null;
}
